export const NAVY_BG = '#011222';
export const NAVY = '#1B3661';
export const YELLOW = '#FFDD0F';
